import { useGetCampaignApiV1Suspense } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { useCampaignId } from "@/routes/campaigns/hooks/use-campaign-id";
import { formatNumber } from "@/utils/format";
import { Progress, Typography } from "@backpac/monica";

export function TargetViewProgress() {
  const id = useCampaignId();
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: { item },
    },
  } = useGetCampaignApiV1Suspense(workspaceId, id);

  // const currentEstimatedView = item.currentEstimatedView > 3000000 ? 3000000 : item.currentEstimatedView;
  const currentEstimatedView = 3000000; // Note: This is a fake value to show the progress bar fully
  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="w-full h-2">
        <Progress
          value={(currentEstimatedView / item.targetView) * 100}
          activeColor="white"
          className="h-2 bg-[#00000040]"
        />
      </div>

      <div className="flex justify-between w-full">
        <Typography className="text-[#ffffffcc] whitespace-nowrap" font="spring" size="xs">
          {currentEstimatedView.toLocaleString()}
        </Typography>
        <Typography className="text-[#ffffffcc] text-right whitespace-nowrap" font="spring" size="xs">
          {item.targetView.toLocaleString()}
        </Typography>
      </div>

      <Typography className="text-[#ffffffcc]" font="spring" size="xs">
        Remaining Views: {formatNumber(item.targetView - currentEstimatedView, 0)}
      </Typography>
    </div>
  );
}
